import {config} from "./config";
import {request} from "./request";

function createItem(data, cb, fail_cb) {
    request.post.call(this, config.apiList.shopMpConfigs, data, {}, cb, fail_cb)
}

function getItems(data, cb, fail_cb) {
    request.get.call(this, config.apiList.shopMpConfigs, data, cb, fail_cb)
}

function deleteItem(data, cb, fail_cb) {
    request.deleteRequest.call(this, config.apiList.shopMpConfigs + "/" + data.id, data, cb, fail_cb)
}


var showMpConfigApi = {
    createItem: createItem,
    getItems: getItems,
    deleteItem: deleteItem
}

export {showMpConfigApi}